import { render, staticRenderFns } from "./fccPublicacaoParametroPadraoTipo.vue?vue&type=template&id=29eb0a39"
import script from "./fccPublicacaoParametroPadraoTipo.vue?vue&type=script&lang=js"
export * from "./fccPublicacaoParametroPadraoTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports